/**
 * Mock GDD (Growing Degree Days) data for the climate chart.
 * ALL data in this file is placeholder — replace with real data hooks when available.
 * GDD5 = base 5°C / 41°F threshold, GDD10 = base 10°C / 50°F threshold.
 */

// Season date range
export const MOCK_GDD_SEASON_START = '2026-03-01'
export const MOCK_GDD_SEASON_END = '2026-11-29'

// Today's date (used to split current GDD into observed vs future-null)
export const MOCK_GDD_TODAY = '2026-03-19'

// Season progress (0–100) — fraction of season days elapsed
export const MOCK_SEASON_PROGRESS = 6

// Frost dates — null if not applicable. isEstimate prepends "est." to the label.
// Date must match an exact entry in MOCK_GDD_SERIES for the reference line to render.
export const MOCK_LFD = { date: '2026-05-10', label: 'LFD', isEstimate: true }
export const MOCK_FFD = { date: '2026-10-04', label: 'FFD', isEstimate: true }

/**
 * Combined series data: each entry has date + all four GDD series.
 * currentGdd5 / currentGdd10 are null after MOCK_GDD_TODAY (future, no observed data).
 */
export const MOCK_GDD_SERIES = [
  { date: '2026-03-01', avgGdd5: 0,    avgGdd10: 0,    currentGdd5: 0,    currentGdd10: 0    },
  { date: '2026-03-08', avgGdd5: 10,   avgGdd10: 4,    currentGdd5: 6,    currentGdd10: 2    },
  { date: '2026-03-15', avgGdd5: 25,   avgGdd10: 10,   currentGdd5: 18,   currentGdd10: 6    },
  { date: '2026-03-19', avgGdd5: 42,   avgGdd10: 16,   currentGdd5: 30,   currentGdd10: 10   },
  { date: '2026-03-22', avgGdd5: 60,   avgGdd10: 24,   currentGdd5: null, currentGdd10: null },
  { date: '2026-03-29', avgGdd5: 90,   avgGdd10: 36,   currentGdd5: null, currentGdd10: null },
  { date: '2026-04-05', avgGdd5: 130,  avgGdd10: 55,   currentGdd5: null, currentGdd10: null },
  { date: '2026-04-12', avgGdd5: 180,  avgGdd10: 78,   currentGdd5: null, currentGdd10: null },
  { date: '2026-04-19', avgGdd5: 240,  avgGdd10: 108,  currentGdd5: null, currentGdd10: null },
  { date: '2026-04-26', avgGdd5: 310,  avgGdd10: 145,  currentGdd5: null, currentGdd10: null },
  { date: '2026-05-03', avgGdd5: 390,  avgGdd10: 190,  currentGdd5: null, currentGdd10: null },
  { date: '2026-05-10', avgGdd5: 480,  avgGdd10: 242,  currentGdd5: null, currentGdd10: null },
  { date: '2026-05-17', avgGdd5: 580,  avgGdd10: 300,  currentGdd5: null, currentGdd10: null },
  { date: '2026-05-24', avgGdd5: 690,  avgGdd10: 368,  currentGdd5: null, currentGdd10: null },
  { date: '2026-05-31', avgGdd5: 810,  avgGdd10: 444,  currentGdd5: null, currentGdd10: null },
  { date: '2026-06-07', avgGdd5: 940,  avgGdd10: 528,  currentGdd5: null, currentGdd10: null },
  { date: '2026-06-14', avgGdd5: 1080, avgGdd10: 620,  currentGdd5: null, currentGdd10: null },
  { date: '2026-06-21', avgGdd5: 1225, avgGdd10: 718,  currentGdd5: null, currentGdd10: null },
  { date: '2026-06-28', avgGdd5: 1370, avgGdd10: 820,  currentGdd5: null, currentGdd10: null },
  { date: '2026-07-05', avgGdd5: 1520, avgGdd10: 925,  currentGdd5: null, currentGdd10: null },
  { date: '2026-07-12', avgGdd5: 1670, avgGdd10: 1030, currentGdd5: null, currentGdd10: null },
  { date: '2026-07-19', avgGdd5: 1820, avgGdd10: 1135, currentGdd5: null, currentGdd10: null },
  { date: '2026-07-26', avgGdd5: 1965, avgGdd10: 1236, currentGdd5: null, currentGdd10: null },
  { date: '2026-08-02', avgGdd5: 2105, avgGdd10: 1330, currentGdd5: null, currentGdd10: null },
  { date: '2026-08-09', avgGdd5: 2240, avgGdd10: 1418, currentGdd5: null, currentGdd10: null },
  { date: '2026-08-16', avgGdd5: 2368, avgGdd10: 1498, currentGdd5: null, currentGdd10: null },
  { date: '2026-08-23', avgGdd5: 2488, avgGdd10: 1570, currentGdd5: null, currentGdd10: null },
  { date: '2026-08-30', avgGdd5: 2600, avgGdd10: 1634, currentGdd5: null, currentGdd10: null },
  { date: '2026-09-06', avgGdd5: 2702, avgGdd10: 1690, currentGdd5: null, currentGdd10: null },
  { date: '2026-09-13', avgGdd5: 2793, avgGdd10: 1739, currentGdd5: null, currentGdd10: null },
  { date: '2026-09-20', avgGdd5: 2873, avgGdd10: 1780, currentGdd5: null, currentGdd10: null },
  { date: '2026-09-27', avgGdd5: 2942, avgGdd10: 1814, currentGdd5: null, currentGdd10: null },
  { date: '2026-10-04', avgGdd5: 3000, avgGdd10: 1842, currentGdd5: null, currentGdd10: null },
  { date: '2026-10-11', avgGdd5: 3048, avgGdd10: 1863, currentGdd5: null, currentGdd10: null },
  { date: '2026-10-18', avgGdd5: 3087, avgGdd10: 1879, currentGdd5: null, currentGdd10: null },
  { date: '2026-10-25', avgGdd5: 3116, avgGdd10: 1891, currentGdd5: null, currentGdd10: null },
  { date: '2026-11-01', avgGdd5: 3138, avgGdd10: 1899, currentGdd5: null, currentGdd10: null },
  { date: '2026-11-08', avgGdd5: 3152, avgGdd10: 1905, currentGdd5: null, currentGdd10: null },
  { date: '2026-11-15', avgGdd5: 3161, avgGdd10: 1908, currentGdd5: null, currentGdd10: null },
  { date: '2026-11-22', avgGdd5: 3167, avgGdd10: 1910, currentGdd5: null, currentGdd10: null },
  { date: '2026-11-29', avgGdd5: 3170, avgGdd10: 1911, currentGdd5: null, currentGdd10: null },
]
